var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 24.93V27C49.4972 31.852 47.9261 36.5731 45.021 40.4591C42.1159 44.3452 38.0324 47.1881 33.3796 48.5638C28.7267 49.9395 23.7538 49.7743 19.2026 48.0928C14.6513 46.4114 10.7655 43.3038 8.12466 39.2334C5.48385 35.1631 4.22953 30.3482 4.54877 25.5067C4.86802 20.6653 6.74372 16.0568 9.89613 12.3684C13.0485 8.68012 17.3088 6.10964 22.0414 5.04036C26.7741 3.97108 31.7256 4.46029 36.1575 6.43503M49.5 9.00003L27 31.5225L20.25 24.7725",
    stroke: "#43D685",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckP);
export default __webpack_public_path__ + "static/media/checkP.13cb9316204b5a14327883ec71fc9fe7.svg";
export { ForwardRef as ReactComponent };